import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6705yv6: FaireProductEntity = {
  token: "p_d6705yv6",
  type: "product",
  name: "Colorful Thanks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e290386bc47ebedb7f1451dedd809dad2c86fcdbb0e922810b8378db2d994e62/1528386060.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/393b1bd8632302454b9c39585241774a88ce03c1a5130dea8f8c8b417efb1dff/1528386060.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:46.058Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
